import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/aurora-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-aurora-colorado",
      statusCode: 301,
    });
  },
});
